import { CompanyFeatures } from "v2/domain/common/enums/CompanyFeatures";

const restoreCompanyFeatures = ({
  content,
}: {
  content: CompanyFeatures[];
}) => {
  type T = keyof typeof CompanyFeatures;

  const features: Record<T, boolean> = {
    TRANSACTION_SUMMARY: false,
    FORECAST: false,
    ALLOWANCE_DELIVERY: false,
    ALLOWANCE_ALERTS: false,
    THRESHOLD_ALERT: false,
    WITHDRAW_FUNDS: false,
    ALLOW_CHANGE_BENEFIT_MODEL: false,
    PAYROLL_REPORT: false,
    ANALYTICS_DASHBOARDS: false,
  };

  content.forEach((companyFeature) => {
    const feature: keyof typeof CompanyFeatures = companyFeature;
    features[feature] = !!CompanyFeatures[feature];
  });

  return features;
};

export default restoreCompanyFeatures;
